const IPIFY_ENDPOINTS = [
  "https://api.ipify.org?format=json",
  "https://api64.ipify.org?format=json",
];

let cachedPublicIp = null;
let pendingLookup = null;

const fetchJsonIp = async (url) => {
  const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
  const timer = controller ? setTimeout(() => controller.abort(), 4000) : null;

  try {
    const response = await fetch(url, {
      method: "GET",
      cache: "no-store",
      signal: controller?.signal,
    });
    if (!response.ok) return null;
    const payload = await response.json();
    const ip = String(payload?.ip || "").trim();
    return ip || null;
  } catch {
    return null;
  } finally {
    if (timer) clearTimeout(timer);
  }
};

const lookupPublicClientIp = async () => {
  for (const url of IPIFY_ENDPOINTS) {
    const ip = await fetchJsonIp(url);
    if (ip) return ip;
  }
  return null;
};

export const getPublicClientIp = async () => {
  if (cachedPublicIp) return cachedPublicIp;
  if (!pendingLookup) {
    pendingLookup = lookupPublicClientIp()
      .then((ip) => {
        cachedPublicIp = ip;
        return ip;
      })
      .finally(() => {
        pendingLookup = null;
      });
  }
  return pendingLookup;
};
